// *******************************************************************************
// Process Module Counter
// *******************************************************************************

const counterEle = document.querySelectorAll('.process-module__counter-count');

if (counterEle.length > 0) {
  let counterEleMagic = null;

  const initCounterScrollMagic = () => {
    counterEleMagic = new ScrollMagic.Controller();

    counterEle.forEach((element) => {
      const countValue = element.getAttribute('data-count');
      element.innerHTML = 0;
      const parentElem = element.closest('.process-module__counter-wrapper');
      const counterInner = parentElem.querySelector('.process-module__counter-pin');
      const stickyElem = parentElem.querySelector('.process-module__counter-sticky');

      const counterTween = gsap.to(element, {
        innerHTML: countValue,
        onUpdate() {
          element.innerHTML = Math.round(this.targets()[0].innerHTML);
        },
      });

      new ScrollMagic.Scene({
        triggerElement: stickyElem,
        duration: '90%',
        triggerHook: 0,
      })
        .setTween(counterTween)
        .setPin(counterInner)
        .addTo(counterEleMagic);
    });
  };

  initCounterScrollMagic();
}
